module.exports={
	"Form": "CustomerEditManifest",
	"Scope": "Customer-Edit",
	"Descriptors":
	{
		"CustomerDetails.GUIDCustomer":
		{
			"Name": "GUID",
			"Hash": "Customer-Edit-GUIDCustomer",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "CustomerEditIdentity",
				"Group": "CustomerEditIdentity"
			}
		},
		"CustomerDetails.Name":
		{
			"Name": "Customer Name",
			"Hash": "Customer-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "CustomerEditIdentity",
				"Group": "CustomerEditIdentity"
			}
		},
		"CustomerDetails.Code":
		{
			"Name": "Customer Code",
			"Hash": "Customer-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerEditSettings",
				"Group": "CustomerEditSettings"
			}
		},
		"CustomerDetails.Timezone":
		{
			"Name": "Timezone",
			"Hash": "Customer-Edit-Timezone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerEditSettings",
				"Group": "CustomerEditSettings"
			}
		},
		"CustomerDetails.Enabled":
		{
			"Name": "Enabled",
			"Hash": "Customer-Edit-Enabled",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "CustomerEditSettings",
				"Group": "CustomerEditSettings"
			}
		},
		"CustomerDetails.CustomProperties":
		{
			"Name": "Custom Properties (JSON)",
			"Hash": "Customer-Edit-CustomProperties",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "CustomerEditCustomProperties",
				"Group": "CustomerEditCustomProperties"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CustomerEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CustomerEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "CustomerEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "CustomerEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "CustomerEditCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "CustomerEditCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
